import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'reactstrap';

import Accordion from '../../components/Accordion';
import AccordionItem from '../../components/Accordion/components/AccordionItem';
import BracketAttachment from './types/BracketAttachment';
import GeneralCalculation from './types/GeneralCalculation';
import RebarReinforcement from './types/RebarReinforcement';
import SafetyBarrier from './types/SafetyBarrier';
import WoodConnection from './types/WoodConnection/WoodConnection';
import { APP_TYPES } from '../../app.config';
import './styles.scss';

import { isValidAppType } from '@services/helper.service';
import { APP_TEXTS } from '../../texts/texts';
import Prompt from '@components/Prompt';

class Application extends Component {

  static propTypes = {
    setAppType: PropTypes.func.isRequired
  };

  static types = APP_TYPES;

  state = {
    showConfirmationPrompt: false,
    pendingAppTypeConfirmation: null
  }

  constructor() {
    super();
    this.accordionRef = null;
  }

  render() {
    return (
      <React.Fragment>
        <section className="position-relative">
          <Prompt
            showDialog={this.state.showConfirmationPrompt}
            message={APP_TEXTS.APPLICATIONS_CHANGE_CONFIRMATION.Content}
            onYes={this.onYes.bind(this)}
            onNo={this.onNo.bind(this)}
          />
          <Row className="position-static">
            <Col sm="12">
              <Accordion
                className="application__accordion"
                appStatus={this.props.appStatus}
                activeItem={this.props.appType + "_Closed"}
                onItemClick={this.showConfirmationPrompt.bind(this)}
                onRef={(ref) => this.accordionRef = ref}
              >
                {isValidAppType(APP_TYPES.GENERAL_CALCULATION, this.props.designStandard) && (
                  <AccordionItem
                    id={APP_TYPES.GENERAL_CALCULATION} title={APP_TEXTS.GENERAL_CALCULATION.Content}
                  >
                    <GeneralCalculation />
                  </AccordionItem>
                )}

                {isValidAppType(APP_TYPES.BRACKET_ATTACHMENT, this.props.designStandard) && (
                  <AccordionItem
                    id={APP_TYPES.BRACKET_ATTACHMENT} title={APP_TEXTS.BRACKET_ATTACHMENT.Content}
                  >
                    <BracketAttachment />
                  </AccordionItem>
                )}

                {isValidAppType(APP_TYPES.SAFETY_BARRIER, this.props.designStandard) && (
                  <AccordionItem
                    id={APP_TYPES.SAFETY_BARRIER} title={APP_TEXTS.SAFETY_BARRIER.Content}
                  >
                    <SafetyBarrier />
                  </AccordionItem>
                )}

                {isValidAppType(APP_TYPES.REBAR_REINFORCEMENT, this.props.designStandard) && (
                  <AccordionItem
                    id={APP_TYPES.REBAR_REINFORCEMENT} title={APP_TEXTS.REBAR_REINFORCEMENT.Content}
                  >
                    <RebarReinforcement />
                  </AccordionItem>
                )}
                {isValidAppType(APP_TYPES.WOOD_CONNECTION, this.props.designStandard) && (
                  <AccordionItem
                    id={APP_TYPES.WOOD_CONNECTION} title={APP_TEXTS.WOOD_CONNECTION.Content}
                  >
                    <WoodConnection />
                  </AccordionItem>
                )}
              </Accordion>
            </Col>
          </Row>
        </section>
      </React.Fragment>
    );
  }

  showConfirmationPrompt(appType) {
    if (this.props.appType !== appType) {
      this.setState({ showConfirmationPrompt: true, pendingAppTypeConfirmation: appType });
      return false;
    }
  }

  onYes() {
    this.props.setAppType(this.state.pendingAppTypeConfirmation);
    this.setState({ showConfirmationPrompt: false, pendingAppTypeConfirmation: null });
    if (this.accordionRef)
      this.accordionRef.onResumeActivation();
  }

  onNo() {
    this.setState({ showConfirmationPrompt: false, pendingAppTypeConfirmation: null });
  }

}

export default Application;



// WEBPACK FOOTER //
// ./src/views/Application/Application.js